import { crashValidatedSummaryUrl } from '../offline/contract'

const SUMMARY_STORAGE_KEY = 'crashValidatedSummary'

/**
 * @param {Record<string, unknown> | null | undefined} raw
 */
export function normalizeCrashesSummary(raw) {
  const n = (key, fallback = 0) => Number(raw?.[key] ?? raw?.[key[0].toUpperCase() + key.slice(1)] ?? fallback)
  if (!raw || typeof raw !== 'object') {
    return {
      total: 0,
      unknownSeverity: 0,
      noInjurySeverity: 0,
      slightInjurySeverity: 0,
      seriousInjurySeverity: 0,
      fatalSeverity: 0,
      totalPeople: 0,
      unknownSeverityPeople: 0,
      noInjurySeverityPeople: 0,
      slightInjurySeverityPeople: 0,
      seriousInjurySeverityPeople: 0,
      fatalSeverityPeople: 0,
    }
  }

  return {
    total: n('total'),
    unknownSeverity: n('unknownSeverity'),
    noInjurySeverity: n('noInjurySeverity'),
    slightInjurySeverity: n('slightInjurySeverity'),
    seriousInjurySeverity: n('seriousInjurySeverity'),
    fatalSeverity: n('fatalSeverity'),
    totalPeople: n('totalPeople'),
    unknownSeverityPeople: n('unknownSeverityPeople'),
    noInjurySeverityPeople: n('noInjurySeverityPeople'),
    slightInjurySeverityPeople: n('slightInjurySeverityPeople'),
    seriousInjurySeverityPeople: n('seriousInjurySeverityPeople'),
    fatalSeverityPeople: n('fatalSeverityPeople'),
  }
}

/**
 * @param {(url: string, method?: string, body?: unknown, headers?: Record<string, string>) => Promise<unknown>} request
 * @param {string} token
 */
export async function fetchCrashValidatedSummary(request, token) {
  const res = await request(
    crashValidatedSummaryUrl(),
    'GET',
    null,
    { Authorization: `Bearer ${token}` },
  )

  if (res?.responseAnyError || res?.responseCode !== 0) {
    throw new Error(res?.responseMessage ?? 'Failed to load crash summary')
  }

  return res.responseData ?? {}
}

/**
 * @returns {ReturnType<typeof normalizeCrashesSummary> | null}
 */
export function loadCachedCrashesSummary() {
  try {
    const stored = localStorage.getItem(SUMMARY_STORAGE_KEY)
    if (!stored) return null
    const parsed = JSON.parse(stored)
    if (!parsed?.data) return null
    return normalizeCrashesSummary(parsed.data)
  } catch {
    return null
  }
}

/**
 * @param {Record<string, unknown>} summary
 */
export function saveCachedCrashesSummary(summary) {
  try {
    localStorage.setItem(
      SUMMARY_STORAGE_KEY,
      JSON.stringify({
        data: normalizeCrashesSummary(summary),
        cachedAt: Date.now(),
      }),
    )
  } catch {
    /* ignore quota errors */
  }
}
